module.exports = __webpack_public_path__ + "static/media/ic-bed.b2b41efd.svg";